import React from "react";

export default function DashboardCards({
    dashboard
}) {

    if (!dashboard) {
        return null;
    }

    return (

        <div className="dashboardCards">

            <div className="dashboardCard">

                <div className="dashboardCardValue">
                    {dashboard.totalLinks || 0}
                </div>

                <div className="dashboardCardLabel">
                    Total Links
                </div>

            </div>

            <div className="dashboardCard">

                <div className="dashboardCardValue">
                    {dashboard.totalClicks || 0}
                </div>

                <div className="dashboardCardLabel">
                    Total Clicks
                </div>

            </div>

            <div className="dashboardCard">

                <div className="dashboardCardValue">
                    {dashboard.activeLinks || 0}
                </div>

                <div className="dashboardCardLabel">
                    Active Links
                </div>

            </div>

            <div className="dashboardCard">

                <div className="dashboardCardValue">
                    {dashboard.inactiveLinks || 0}
                </div>

                <div className="dashboardCardLabel">
                    Inactive Links
                </div>

            </div>

        </div>

    );

}